angular.module('impactx.ruleset').controller('RuleBudgetCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'ToastService',
    'TranslationService',
    'BackService',
    'WarningService',
    'ToolbarService',
    RuleBudgetCtrl
]);

function RuleBudgetCtrl($scope, dataGen, $routeParams, ToastService, TranslationService, BackService, WarningService, ToolbarService) {
    var self = this;
    $scope.budgetTypeArray = [{field: "baseType", value: 0}];

    dataGen.getData($scope, {
        id: $routeParams.id,
        ruleSetId: $routeParams.ruleSetId,
        ruleType: $routeParams.ruleType
    }, "/ruleset/viewbudgetrule").then(function () {
        $scope.budgetTypeArray[0].value = impactX.isDefined($scope.data.budget, 'budgetType.selected.id');
        $scope.trns.required = TranslationService.get('required');
        $scope.trns.save = TranslationService.get('save');
        $scope.trns.delete = TranslationService.get('delete');
        $scope.trns.noSelectedItemMessage = TranslationService.get('noSelectedItemMessage');

        defineButtons();
    });

    self.save = function (event) {
        if (!impactX.isDefined($scope.data.budget, 'budget.selected.id')) {
            WarningService.showWarningDialog(self.doSave, event, $scope.trns.warning, $scope.trns.save,
                $scope.trns.abort, [$scope.trns["missingBudget" + $scope.data.budget.budgetType.selected.id]]);
        }
        else {
            return self.doSave();
        }
    };

    self.doSave = function () {
        return dataGen.postAsForm($scope, {formData: $scope.data}, "/ruleset/savebudgetrule").then(function () {
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            BackService.back();
        });
    };

    self.changeBudgetType = function (newValue, oldValue) {
        $scope.budgetTypeArray[0].value = $scope.data.budget.budgetType.selected.id;
        if (oldValue && (!newValue || oldValue.id !== newValue.id)) {
            $scope.data.budget.budget.selected = {};
        }
    };

    self.delete = function () {
        return dataGen.postAsForm($scope, {id: $scope.data.id}, "/ruleset/deleterule").then(function () {
            ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
            BackService.back();
        });
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: self.save,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.delete,
                action: self.delete,
                type: 'dialogaction',
                condition: canDelete
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.readOnly;
    }

    function canDelete() {
        return isEditable() && $scope.data.id > 0;
    }
}